import React from "react";
import PropTypes from "prop-types";
import TextField from "@mui/material/TextField";
import decodeHTMLEntities from "../../helpers/decodeHTMLEntities";
import getStyled from "../../hooks/getStyled";
import { InputAdornment } from "@mui/material";
import InputErrorLabel from "../inputErrorLabel";
import SFTypography from "../typography";

const { styled } = getStyled();

const SFTypographyStyled = styled(SFTypography, { shouldForwardProp: false })(
  ({ theme, hasError }) => ({
    position: "absolute",
    right: 0,
    bottom: hasError ? 1 : -20,
  })
);

const SFTextField = ({
  label,
  onBlur,
  onFocus,
  startAdornment,
  maxLength = null,
  hasHtml,
  textIcon = null,
  isCopilotField = false,
  ...props
}) => {
  const [isFocused, setIsFocused] = React.useState(false);

  const MaxLengthValue = (length, maxLength, hasError) => (
    <SFTypographyStyled variant="textLink" color="blue300" hasError={hasError}>
      {length}/{maxLength}
    </SFTypographyStyled>
  );

  return (
    <div style={{ position: "relative", width: "100%" }}>
      <TextField
        disabled={props.disabled}
        label={label}
        error={props.errors?.length > 1}
        {...(props.errors && {
          helperText: <InputErrorLabel label={props.errors} />,
        })}
        FormHelperTextProps={{ component: "div" }}
        onFocus={() => {
          setIsFocused(true);
          onFocus && onFocus();
        }}
        onBlur={(e) => {
          setIsFocused(false);
          onBlur && onBlur(e);
        }}
        InputProps={{
          startAdornment: textIcon ? (
            <InputAdornment position="start">{textIcon}</InputAdornment>
          ) : null,
          ...props.InputProps,
        }}
        {...(maxLength && {
          inputProps: { maxLength, ...props.inputProps },
        })}
        value={hasHtml ? decodeHTMLEntities(props.value) : props.value}
        {...props}
        isCopilotField={isCopilotField}
      />
      {maxLength &&
        isFocused &&
        MaxLengthValue(props.value.length, maxLength, props.errors?.length > 1)}
    </div>
  );
};

SFTextField.defaultProps = {
  variant: "outlined",
  fullWidth: true,
  size: "medium",
};

SFTextField.propTypes = {
  onChange: PropTypes.func,
  onKeyUp: PropTypes.func,
  onKeyDown: PropTypes.func,
  hiddenLabel: PropTypes.bool,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
  fullWidth: PropTypes.bool,
  bgColor: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  variant: PropTypes.oneOf(["outlined", "filled", "standard"]),
  size: PropTypes.oneOf(["small", "medium"]),
  textIcon: PropTypes.node, // Add prop type for textIcon
};

export default SFTextField;
